const KEY = "autopulse.history.v1";

export function loadHistory() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function saveHistory(entry) {
  const list = loadHistory();
  list.unshift(entry);
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 25)));
}

export function clearHistory() {
  localStorage.removeItem(KEY);
}
